import React, { useState ,useContext,useEffect} from "react";
import { Routes, Route,Link } from 'react-router-dom';


import useTable from "../../hooks/useTable";
import './Table.css';
import TableFooter from "./FooterTable";
import DataItemPage from '../../Pages/DataItemPage';
import {getIcon,getItemVal} from "../../Data/GeneralFanction"
import {  LanguageContext } from '../../context';
import DataInfo from "../DataInfo/DataInfo";
import Translate from "../Translate/Translate";

const Table = ({ data, rowsPerPage,changeFilters }) => {
  
  const [page, setPage] = useState(1);
  const [expandedRows, setExpandedRows] = useState({});
  const { slice, range,currPage } = useTable(data, page, rowsPerPage);
  const { language } = useContext(LanguageContext);

  var config = require('../../config.json');

 

  useEffect(() => {
    setExpandedRows({});
  }, [slice]);

  useEffect(() => {
    
      setPage(currPage);
  }, [currPage]);



 
  const getAllIconsRelevant=(el)=>{
   
    const tabsData=config.DataItemTabs;
    return (
    <>
    {/* {
      tabsData.map((tab,index)=>{
        
       return <>{index>0 && index<5 && getItemVal(tab.field[language],el)!=null && <Link to={{pathname:`/${language}/dataItem/${el.ID.Value}/${tab.label.en}`}} key={index} ><img src={getIcon(tab.icon)} alt=""></img></Link>}</>
      })
    } */}

{
      tabsData.map((tab,index)=>{
        var flag=false;  
        var fieldCheck=tab.field[language].split(';') ; 
        fieldCheck.map((field,i)=>{
          var val=getItemVal(field,el);
          flag=flag ? true : (val != null && val.trim() != '' ? true : false);
        })  
       return <>{index>0 && index<5 && flag && <Link to={{pathname:`/${language}/dataItem/${el.ID.Value}/${tab.label.en}`}} key={index} title={`${tab.label[language]} - ${getDataSetName(el)}`} ><img src={getIcon(tab.icon)} alt=""></img></Link>}</>
      })
    }
     
    </>)
  }

  

  const getDataSetName=(el)=>{
    return language==='he'?el.ds_name_heb.Value:el.ds_name_en.Value;
  }

  const isRowExpanded=(el)=>{
    return !!expandedRows[el.ID.Value];
  }

  const getExpandTitle=(el)=>{
    const dataSetName=getDataSetName(el);
    const isExpanded=isRowExpanded(el);
    const actionTitle=language==='he'?(isExpanded?'סגור מידע נוסף':'פתח מידע נוסף'):(isExpanded?'Close more info':'Open more info');
    return `${actionTitle} - ${dataSetName}`;
  }

  const showHideMore=(el)=>{
    setExpandedRows((currentExpandedRows)=>({
      ...currentExpandedRows,
      [el.ID.Value]: !currentExpandedRows[el.ID.Value]
    }));
  }

const updateParamsFilter=(categoryF,typeF)=>{
  changeFilters({categoryF,typeF});
}

  return (
    <>
   
   {data.length==0 && <h2 className="result-not-found"><Translate>NotFoundResults</Translate></h2>}
   {
    data.length>0 &&  <table className="table">
        <thead className="tableRowHeader">
          <tr>
            <th className="tableHeader"></th>            
            <th className="tableHeader"><Translate>DataBases</Translate></th>
            <th className="tableHeader"><Translate>ViewType</Translate></th>
            {/* <th className="tableHeader"><Translate>UpdateDate</Translate></th> */}
            
            <th className="tableHeader"><Translate>MoreInfo</Translate></th>
          </tr>
        </thead>
        <tbody>
          {slice.map((el,index) => (
              <>
              <Routes>
    <Route path='/dataItem/:id/:selectedTab' element={<DataItemPage data /> } exact />
    </Routes>
            <tr className="tableRowItems" key={index} onClick={()=>showHideMore(el)}>
              
              <td className="tableCell">{el.ds_islive.Value=="True"?<div className="live-icon"/>:""}</td>
              <td className="tableCell">{getDataSetName(el)}</td>
              <td className="tableCell links-item">
               {getAllIconsRelevant(el)}                
              </td>
              {/* <td className="tableCell">{el.Modified.Value.substring(0,el.Modified.Value.indexOf(' ')).replaceAll(',','.')}</td> */}
             
              <td className="tableCell"><a className={isRowExpanded(el)?"expand-link active":"expand-link"} href="javascript:return false;" title={getExpandTitle(el)} ><div></div></a></td>
              
            </tr>
            <tr className={isRowExpanded(el)?"tableRowInnerItems active":"tableRowInnerItems"}>
                <td colSpan="100%">
                    <div className="expandRow">
                      <DataInfo tab={config.DataItemTabs[0]} dataSet={el} showTitle={false}/>

                    </div>
                </td>

            </tr>
            </>
          ))}
        </tbody>
      </table>
      }
     {range.length>1 && <TableFooter range={range} slice={slice} setPage={setPage} page={page} />}
         
    
     
    </>
  );
};

export default Table;